module.exports = __webpack_public_path__ + "static/1-d773677c988322f1be8675fa48b37904.jpg";